<template>
  <div class="widgetwrapper">
    <div width="100%" height="100%" v-bind:style="{ color: color, fontSize: fontSize + 'px' }" >{{label}}</div>
  </div>
</template>

<script>

export default {
  name: 'TextWidget',

  computed: {
    label() {
      return this.widgetData.label
    },

    color() {
      return this.widgetData.color
    },

    fontSize() {
      return this.widgetData.fontSize
    }


  },

  props: {
    widgetData: Object
  },

  methods: {
    requestData() {},
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.widgetwrapper {
  background-color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>
